var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCustomCart(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    stroke: "#260e00",
    viewBox: "10 10 80 80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        stroke-width: 3.4016px;\n      }\n\n      .cls-1, .cls-2 {\n        fill: none;\n        stroke-miterlimit: 10;\n      }\n\n      .cls-2 {\n        stroke-width: 3.1123px;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M20.4784,41.3024l9.9287,42.1646c.2127.9033,1.0188,1.5416,1.9468,1.5416h35.2924c.928,0,1.7341-.6383,1.9468-1.5416l9.9287-42.1646c.2956-1.2555-.6569-2.4584-1.9468-2.4584H22.4251c-1.2898,0-2.2424,1.2029-1.9468,2.4584Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 21.7839,
    y1: 50,
    x2: 78.2161,
    y2: 50
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 26.3784,
    y1: 62.2526,
    x2: 73.6216,
    y2: 62.2526
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 29.3784,
    y1: 74.5051,
    x2: 70.6216,
    y2: 74.5051
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 34.7937,
    y1: 38.844,
    x2: 43.6995,
    y2: 85.0086
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 63.8311,
    y1: 38.844,
    x2: 54.9252,
    y2: 85.0086
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M26.4769,37.771h0c0-6.4038,5.1913-11.5952,11.5952-11.5952h23.8558c6.4038,0,11.5952,5.1913,11.5952,11.5952h0"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomCart);
export default __webpack_public_path__ + "static/media/custom_cart.397fe5339165f4d9be5dae52b2349238.svg";
export { ForwardRef as ReactComponent };